<template>
  <v-dialog v-model="propDialogo" width="800px" persistent>
    <template v-slot:default>
      <div style="position: relative;">
        <!-- Imagen con scroll -->
        <div style="max-height: 500px; overflow-y: auto;">
          <v-img :src="`${$env.pathImg}/${infoPopup.imagen_ruta}`" alt="Drone" width="100%" height="100%" contain />
        </div>

        <!-- Ícono encima del contenedor (fuera del scroll) -->
        <v-icon style="position: absolute; top: 12px; right: 12px; z-index: 10;background: white; border-radius: 50%;"
          color="#0D47A1" large @click="$emit('cerrarDialogo')">
          mdi-close-circle
        </v-icon>
        <div class="center">
          <v-btn dark rounded :color="$ajustes.colorTexto2" :style="{ color: $ajustes.colorTexto1 }" border
            style="position: absolute; bottom:  12px; z-index: 10; text-transform: none; left: 50%; transform: translateX(-50%); text-transform: none; font-size: large;"
            @click="botonAccion()">{{ infoPopup.tipo == 2 ? 'Inscribirse' : (infoPopup.tipo == 1 ? 'Abrir enlace' :
              'Cerrar') }}</v-btn>
        </div>
      </div>
      <v-dialog v-model="formularioDialogo" width="400px">
        <formulario :propId="infoFormulario.id" :propIndicacion="infoFormulario.indicacion"
          :propAsunto="infoFormulario.asunto" @propCerrarFormulario="formularioDialogo = false" />
      </v-dialog>
    </template>

  </v-dialog>
</template>

<script>
import axios from 'axios';
import formulario from "@/components/template/formulario";
import QRCode from "qrcode";
export default {
  components: {
    formulario
  },
  props: {
    propDialogo: { type: Boolean },
    propPopup: { type: Object },
    propGenNewQr: { type: String },
  },
  data() {
    return {
      formularioDialogo: false,
      remote: false,
      remoteCode: "",
      idPcOwner: "",
      sms: "",
      infoPopup: {
        id: "",
        titulo: "",
        imagen_ruta: "",
        tipo: 0,
        enlace: ""
      },
      infoFormulario: {
        id: "",
        titulo: "",
        imagen_ruta: "",
        tipo: "",
        indicacion: "",
        enlace: ""
      }
    };
  },
  mounted() {
    this.obtenerPopupHabilitado()

  },
  created() { },
  watch: {
    propPopup() {
      if (this.propPopup.id) {
        this.infoPopup.id = this.propPopup.id
        this.infoPopup.titulo = this.propPopup.titulo
        this.infoPopup.imagen_ruta = this.propPopup.imagen_ruta
        this.infoPopup.tipo = this.propPopup.tipo
        this.infoPopup.enlace = this.propPopup.enlace
      }
    },
    propGenNewQr() {
      this.genQr();
    },
  },
  methods: {
    botonAccion() {
      switch (this.infoPopup.tipo) {
        case 2:
          this.infoFormulario.id = this.infoPopup.id
          this.infoFormulario.indicacion = "¿Estas interesado en participar en el curso o taller de: " + this.infoPopup.titulo + "?"
          this.infoFormulario.asunto = "Interesado en " + this.infoPopup.titulo
          this.formularioDialogo = true
          break;
        case 1:
          window.open(this.infoPopup.enlace, '_blank');
          break;
        case 0:
          this.$emit('cerrarDialogo')
          break
        default:
          break;
      }
    },
    async obtenerPopupHabilitado() {
      return await axios.get("/obtener_popup_habilitado")
      .then((response) => {
        if (response.data) {
          this.infoPopup.id=response.data.data.id;
          this.infoPopup.titulo=response.data.data.titulo;
          this.infoPopup.imagen_ruta=response.data.data.imagen_ruta;
          this.infoPopup.tipo=response.data.data.tipo;
          this.infoPopup.enlace=response.data.data.enlace;
          this.$emit('activarPopupDialogo')
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    goto(aux) {
      this.$emit('closeDialog')
      this.$router.push({ name: aux })
    },

    async genQr() {
      try {
        this.idPcOwner = this.$route.params.idpcowner.toString();
      } catch (error) {
        this.idPcOwner = "";
      }
      try {
        if (this.idPcOwner.length < 2) {
          this.idPcOwner = localStorage.getItem("miIdPc");
        }
        var qrPath = window.location.href;
        let qrCanvas = await QRCode.toCanvas(qrPath, {
          color: {
            dark: "#0000FF", // Azul (color de los cuadrados del QR)
            light: "#FFFFFF", // Blanco (fondo)
          },
        });
        // Limpiar contenido anterior
        this.$refs.qrcode.innerHTML = "";
        this.$refs.qrcode.appendChild(qrCanvas);
      } catch (err) {
        console.error("Error generando QR:", err);
      }
    },
    gotox(remote) {
      if (!remote) {
        this.$router.push({
          name: "Notes",
          params: { idpc: localStorage.getItem("miIdPc") },
        });
      } else {
        localStorage.setItem("remoteCode", remote);
        this.$router.push({ name: "Notes", params: { idpc: remote } });
      }
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.qr-wrapper {
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
</style>
